import styled from 'styled-components';

const dividerStyles = (color: string): string => `
  border-top: 1px solid ${color};
  padding-top: 24px;
`;

export const Box = styled.div<{ isReviewed: boolean }>`
  margin-bottom: 24px;
  ${(prop) => !prop.isReviewed && dividerStyles(prop.theme.colors['neutral-30'])}
`;

export const SpaceBetweenBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ReviewerBox = styled(SpaceBetweenBox)`
  margin-bottom: 12px;
`;

export const ExpandBox = styled.button`
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 150%;
  color: ${(prop) => prop.theme.colors['neutral-90']};

  svg {
    font-size: 14px;
    margin-left: 6px;
  }
`;

export const ReviewInfos = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ReviewerName = styled.span`
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  color: ${(prop) => prop.theme.colors['neutral-90']};
  margin-right: 8px;
`;

export const ReviewTime = styled.span`
  font-size: 10px;
  line-height: 140%;
  color: ${(prop) => prop.theme.colors['neutral-90']};
`;

export const ReviewerScoreBox = styled.div`
  display: flex;
  flex: 1;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  border: 1px solid ${(props) => props.theme.colors['neutral-40']};
  border-top: none;
  background: ${(props) => props.theme.colors['neutral-20']};
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
`;

export const ReviewerScore = styled.p`
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  color: ${(prop) => prop.theme.colors['neutral-70']};

  span {
    color: ${(prop) => prop.theme.colors['primary-60']};
  }
`;

export const OverviewBox = styled.div`
  margin-top: 12px;
`;

export const ButtonsBox = styled(SpaceBetweenBox)`
  div {
    display: flex;
  }
  margin-top: 12px;
`;
